import { render, staticRenderFns } from "./SelectPfdoMun.vue?vue&type=template&id=383cae03&lang=pug"
import script from "./SelectPfdoMun.vue?vue&type=script&lang=js"
export * from "./SelectPfdoMun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports